import { render } from "./RAMIcon.vue?vue&type=template&id=29bab828&ts=true"
import script from "./RAMIcon.vue?vue&type=script&lang=ts"
export * from "./RAMIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__